module.exports = __webpack_public_path__ + "img/hongkong_000.47bd02ad.jpg";